const formatNumber = (value, locale, decimalPlaces = 2, minDecimalPlaces = null) => {
  const minimumDecimalPlaces = minDecimalPlaces === null ? decimalPlaces : minDecimalPlaces;

  return new Intl.NumberFormat(
    locale, {
      minimumFractionDigits: minimumDecimalPlaces,
      maximumFractionDigits: decimalPlaces,
      style: 'decimal',
      useGrouping: true,
    },
  ).format(value);
};

export const getNumberSeparators = (locale) => {
  const parts = new Intl.NumberFormat(locale, {
    style: 'decimal',
    useGrouping: true,
  }).formatToParts(1234.5);

  const thousandSeparator = parts.find(part => part.type === 'group')?.value || '';
  const decimalSeparator = parts.find(part => part.type === 'decimal')?.value || '';

  return {
    thousandSeparator,
    decimalSeparator,
  };
};

export default formatNumber;
